import React from "react";

import type { IPartnerUserSlim } from "App/Modules/Models";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faSirenOn } from "@fortawesome/pro-solid-svg-icons";

type PartnerUsersListProps = {
    users: IPartnerUserSlim[];
};

export const PartnerUsersList = (props: PartnerUsersListProps) => {
    const { t } = useTranslation();
    const { users } = props;

    const findIconByRole = (user) => {
        if (user.role?.name === "PartnerOperator") {
            return faSirenOn;
        }
        return faUsers;
    };

    return (
        <ul className="entity-list">
            {users?.map((u) => (
                <li className="entity-list__item" key={u.id}>
                    <a href={`#!/partners/${u.partner.id}/users/${u.id}`} className="entity-list__item-link">
                        <div className="entity-list__item-panel entity-list__item-panel--top-align">
                            <div className="entity-list__item-value">
                                <p className="paragraph paragraph--small paragraph--bold paragraph--no-spacing">
                                    {u.displayName}
                                </p>
                                <p className="caption caption--no-spacing">{u.email}</p>
                                {u.phoneNumber && u.phoneNumber === u.smsNumber ? (
                                    <p className="caption caption--no-spacing">
                                        {t("Entities.PartnerUser.Tel")}/{t("Entities.PartnerUser.Sms")}: {u.phoneNumber}
                                    </p>
                                ) : (
                                    <React.Fragment>
                                        {u.phoneNumber ? (
                                            <p className="caption caption--no-spacing">
                                                {t("Entities.PartnerUser.Tel")}: {u.phoneNumber}
                                            </p>
                                        ) : null}{" "}
                                        {u.smsNumber ? (
                                            <p className="caption caption--no-spacing">
                                                {t("Entities.PartnerUser.Sms")}: {u.smsNumber}
                                            </p>
                                        ) : null}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                        <div className="entity-list__item-panel entity-list__item-panel--top-align">
                            <div className="entity-list__item-value">
                                <span className="caption">
                                    <FontAwesomeIcon icon={findIconByRole(u)} fixedWidth />
                                    {u.role ? t(`Entities.Role.${u.role.name}`) : t("Entities.Role.NoRole")}
                                </span>
                            </div>
                        </div>
                        <div className="entity-list__item-panel entity-list__item-panel--top-align">
                            <div className="entity-list__item-value">
                                {u.labels.map((l, i) => (
                                    <div key={i} className="state-tag state-tag--info">
                                        {l.label}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </a>
                </li>
            ))}
        </ul>
    );
};
